import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NetworkLockedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"network_locked"}/>
}
